import { createContext, useContext, ReactNode } from 'react'
import { useDeviceInfo, DeviceInfo } from '../framework/pylot/hooks/deviceInfo'

interface DeviceContextType {
    deviceInfo: DeviceInfo | null
}

const DeviceContext = createContext<DeviceContextType>({ deviceInfo: null })

export const DeviceProvider = ({ children }: { children: ReactNode }) => {
    const deviceInfo = useDeviceInfo()

    return (
        <DeviceContext.Provider value={{ deviceInfo }}>
            {children}
        </DeviceContext.Provider>
    )
}

export const useDeviceContext = (): DeviceContextType => {
    const context = useContext(DeviceContext)

    if (!context) {
        console.error(
            '❌ ERROR: useDeviceContext se está llamando fuera de DeviceProvider'
        )
        throw new Error('useDeviceContext debe usarse dentro de DeviceProvider')
    }

    return context
}
